module.exports = __webpack_public_path__ + "assets/img/center_icon11.4b3b6424.svg";